import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/marketplace/Logo";

const COLUMNS = [
  {
    title: "Studio",
    links: [
      { to: "/about", label: "About" },
      { to: "/how-it-works", label: "How it works" },
      { to: "/blog", label: "Journal" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Commission",
    links: [
      { to: "/categories", label: "Categories" },
      { to: "/jewellery-cad-outsourcing", label: "CAD outsourcing" },
      { to: "/register", label: "Get started" },
      { to: "/freelancer/apply", label: "Design with us" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/terms", label: "Terms & Conditions" },
      { to: "/privacy-policy", label: "Privacy Policy" },
      { to: "/refund-policy", label: "Refund Policy" },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t hairline mt-16 md:mt-24 relative z-10">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-10">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Logo className="h-9 w-9" />
              <span className="font-serif text-2xl tracking-wide">GetJewelDesigns</span>
            </Link>
            <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
              A managed studio for bespoke jewellery CAD. Discreet, verified specialists — one transparent
              price per project.
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <div className="text-xs uppercase tracking-widest text-muted-foreground/70 mb-4">{col.title}</div>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t hairline flex flex-wrap gap-4 justify-between text-xs text-muted-foreground tracking-widest uppercase">
          <div>© {year} GetJewelDesigns — Bespoke Jewellery Design Studio</div>
          <div className="opacity-60">Work delivered by verified independent design specialists under the GetJewelDesigns Design Team programme.</div>
        </div>
      </div>
    </footer>
  );
}
